module.exports = __webpack_public_path__ + "img/selo-gptw.d3f0cf63.png";